// composables/useEventColors.js
/* eslint-disable camelcase */

function getFormatColor(format) {
  const colors = {
    entero: '#93C5FD', // Azul claro correcto
    harinado: '#EC4899', // Rosa más intenso
    multiparticle: '#8B5CF6', // Púrpura más intenso
    pelet_3: '#10B981', // Verde más intenso
    pelet_6: '#F59E0B', // Amarillo más intenso
    pelet_8: '#8B5CF6', // Púrpura más intenso
    pelet_12: '#F97316', // Naranja más intenso
  };

  return colors[format] || '#000000'; // Negro para formatos desconocidos (molido, microingredientes, etc.)
}

function getPackagingBorderColor(packaging) {
  const colors = {
    granel: '#6B7280', // Gris más oscuro y visible
    ensacado: '#1E40AF', // Azul más oscuro y visible
    maxisaco: '#D97706', // Naranja más oscuro y visible
  };

  return colors[packaging] || '#6B7280';
}

function getEventClass(format, packaging) {
  const f = format || 'other';
  const p = packaging || 'other';

  return `format-${f} packaging-${p}`;
}

function ensureColorClass(hex, dynamicColorClasses) {
  const cls = `clr-${hex.slice(1).toLowerCase()}`;

  if (dynamicColorClasses.has(cls)) return cls;

  const styleTag = document.createElement('style');

  styleTag.innerHTML = `
    .vuecal-custom .vuecal__event.${cls}{
      background:${hex} !important;
      border:1px solid ${hex};
      color:#fff !important;
      font-size:11px;
      font-weight:500;
      cursor:pointer;
      margin:2px;
      border-radius:2px;
      padding:2px 4px;
      height:auto;
      min-height:18px;
      line-height:1.2;
    }`;
  document.head.appendChild(styleTag);
  dynamicColorClasses.add(cls);

  return cls;
}

export default function useEventColors() {
  return {
    getFormatColor,
    getPackagingBorderColor,
    getEventClass,
    ensureColorClass,
  };
}
